var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientLayout',[_c('PackList',{attrs:{"client-id":_vm.clientId,"packs":_vm.packs},on:{"deleted":function($event){_vm.packs = _vm.packs.filter(function (p) { return p.uuid !== $event.uuid; })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }